import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import ZSearch from '../../../../../components/Common/ZSearch';
//import PopupCustomized from '../../../../../components/PopupCustomized';
import { cloneArray, getOnlyUnique, isDefined, sortReactTable } from '../../../../../utils';
import { columnsAccessors, teamsFilters, jibedTeamThreshold } from '../../../../../constants';
//import GreenDownArrowIcon from '../../../../../icons/GreenDownArrowIcon';
//import RedUpArrowIcon from '../../../../../icons/RedUpArrowIcon';
import SortIcon from '../../../../../icons/v3/SortIcon';

//import HelpOutline from '@material-ui/icons/HelpOutline';
//import HighlightOffIcon from '@material-ui/icons/HighlightOff';
//import FilterIcon from '../../../../../icons/FilterIcon';
//import FilterIconBack from '../../../../../icons/FilterIconBack';
//import CloseFilterIcon from '../../../../../icons/CloseFilterIcon';
//import MinMaxSelectorFilter from '../../../../../components/v3/CalibrationScreenV3/MinMaxSelectorFilter';

class TeamsTableForManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showHelpPopup: false,
            searchTeamQuery: undefined,
            //showFiltersHeader: false,
        };
        this.onSearchTeam = this.onSearchTeam.bind(this);

        this.showHelpPopup = this.showHelpPopup.bind(this);
        this.closeHelpPopup = this.closeHelpPopup.bind(this);

        //this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        //this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);
    }

    showHelpPopup(e) {
        this.setState({ showHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeHelpPopup() {
        this.setState({ showHelpPopup: false });
    }

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
            } = this.props;
        let nameHeader =
            (<div className="flex-container-center">
                <div>Team</div>
                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
            </div>);

        let jibedAgentsHeader =
            (<div className="flex-container-center">
                <div>Jibed Agents</div>
                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
            </div>);
        let jibeSessionsLastMonthHeader =
            (<div className="flex-container-center">
                <div>Jibe Sessions Last 30 Days</div>
                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
            </div>);


        //if (this.state.showFiltersHeader) {
        //    nameHeader = (<ZSearch placeHolder="Search team name" searchValue={this.state.searchTeamQuery} onChange={this.onSearchTeam} />)
        //    jibedAgentsHeader = (<div className="table-header-filter min-max-type">Jibed Agents</div>);
        //    jibeSessionsLastMonthHeader = (<div className="table-header-filter min-max-type">Jibe Sessions Last Month</div>);
        //}

        const nameColumn = {
            Header: nameHeader,
            accessor: columnsAccessors.name,
            //width: 274
        };

        const columns = [nameColumn];

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                let questionHeader =
                    (<div className="flex-container-center">
                        <div>{sq.shortName}(%)</div>
                        <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
                    </div>);
                columns.push(
                    {
                        Header: questionHeader,
                        accessor: `${sq.questionCode}ToShow`,
                        //width: 100
                    }
                );
            });
        }

        columns.push(
            {
                Header: jibeSessionsLastMonthHeader,
                accessor: columnsAccessors.sessionCnt,
                //width: 200
            });

        return columns;
    }

    render() {
        const
            {
                teamsCalibrationStats,
                calibratedOnSurveyQuestions,
                //jibeSessionsPast30Days,
                onClick
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();

        const loading = (!isDefined(teamsCalibrationStats) || !isDefined(calibratedOnSurveyQuestions));
        if (loading === true) {
            return (<ReactTable
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        const teamsCalibrationStatsCopy = cloneArray(teamsCalibrationStats);

        var teamsNames = teamsCalibrationStatsCopy.map(p => p.aggregationName).filter(getOnlyUnique);
        if (!isDefined(teamsNames)) {
            return <div></div>;
        }

        const teamsData = teamsNames.map(teamName => {
            let valuesForQ = [];
            calibratedOnSurveyQuestions.map(cq => {
                const questionValue = teamsCalibrationStatsCopy.find(a => a.questionCode === cq.questionCode && a.aggregationName === teamName);
                valuesForQ.push({ name: cq.questionCode, value: isDefined(questionValue) ? questionValue.overalSuccessRatePercent : undefined },)
            });

            const teamIdInfo = teamsCalibrationStatsCopy.find(a => a.aggregationName === teamName);
            const teamJibeSessionCount = isDefined(teamIdInfo) ? teamIdInfo.sessionCnt : 0;
            valuesForQ.push({ name: "JibeSession", value: teamJibeSessionCount });
            return {
                teamId: teamIdInfo.aggregationId,
                name: teamName,
                values: valuesForQ
            }
        });

        result.data = (teamsData && Array.isArray(teamsData))
            ? teamsData.filter(t => t.name !== "All Teams")
            : [];
        const numberOfTeamsLabel = `(${result.data.length} Teams)`;

        //filter by teamName
        if (isDefined(this.state.searchTeamQuery) && this.state.searchTeamQuery !== '') {
            result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchTeamQuery.toLowerCase()));
        }

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)/* && isDefined(row.agentCount)*/) {
                    const firstLetter = row.name.charAt(0).toUpperCase();
                    row.name = <div style={{ textAlign: 'start' }}>
                        <div className="first-letter-avatar">
                            {firstLetter}
                        </div>

                        {row.name}{/* <span style={{ color: '#70CFD6' }}>({row.agentCount} Agents)</span>*/}
                    </div>;
                }

                if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                    calibratedOnSurveyQuestions.forEach(sq => {
                        const sqData = row.values.find(v => v.name === sq.questionCode);
                        if (isDefined(sqData)) {
                            const avatarStyle = sqData.value >= jibedTeamThreshold ? "percentage-green-avatar" : "percentage-red-avatar";
                            row[`${sq.questionCode}ToShow`] = (<div className={avatarStyle}>
                                {sqData.value}
                            </div>);
                        }
                    });
                }

                const sessionData = row.values.find(v => v.name === 'JibeSession')
                row.sessionCnt = sessionData.value;
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            onClick(rowInfo.original.teamId)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        const teamNameSearchNode = (<ZSearch placeHolder="Search team name" searchValue={this.state.searchTeamQuery} onChange={this.onSearchTeam} />)

        return (<div>
            <div className="teams-table-for-manager filters-wrapper">
                <div className="teams-table-for-manager filter-area-title-wrapper">
                    <label className="teams-table-for-manager all-teams-title">All Teams</label>
                    <label className="teams-table-for-manager number-of-teams-title">{numberOfTeamsLabel}</label>
                </div>
                <div>
                    {teamNameSearchNode}
                </div>
                {/*
                <div className="teams-table-for-manager teams-filter-names-wrapper">
                    Export list of teams
                </div>
                */}
            </div>

            <div style={{ position: 'relative', zIndex: 0 }}>
                {/*
                {!this.state.showFiltersHeader &&
                    <div onClick={this.showFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 2,
                        right: '0',
                        cursor: 'pointer'
                    }}>
                        <FilterIconBack />
                    </div>}
                {!this.state.showFiltersHeader &&
                    <div onClick={this.showFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 3,
                        right: '0',
                        cursor: 'pointer'
                    }}>
                        <FilterIcon />
                    </div>}

                {this.state.showFiltersHeader &&
                    <div onClick={this.hideFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 2,
                        right: '9px',
                        top: '9px',
                        cursor: 'pointer'
                    }}>
                        <CloseFilterIcon />
                    </div>}
                    */ }
                {teamsResultTable}
            </div>

        </div>);
    };
}

const select = state => ({ ...state.CalibrationV3Screen });
export default connect(select)(TeamsTableForManager);
